/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import { useContext, useEffect, useMemo, useState } from 'react';

// @material-ui
import {
  Paper,
} from "../../../components/shared/MaterialUI";

// @assets
import { PayrollStyle } from '../../../assets/css/payroll-style';

// @components
import DialogNotes from '../Edit/DialogNotes';
import EditItemPayroll from '../Edit/EditItemPayroll';
import InvoiceSumary from './InvoiceSumary';
import ToolbarPayroll from './components/ToolbarPayroll';
import FilterCompany from './components/FilterCompany';
import YTDModal from './components/YTDModal';
import ConfirmationDialog from '../../../components/dialog/DialogConfirm';
import DialogNewTargetGroup from '../../../pages/payroll/PayrollTable/components/DialogNewTargetGroup';
import HierarchicalPayrollTable from './components/HierarchicalPayrollTable';

// @context
import { payrollContext } from '../payrollView';

// @helpers
import AppHelper from '../../../helpers/AppHelper';

// @services
import PayrollService from '../../../services/newApi/PayrollService';
import { useUI } from '../../../app/context/ui';
import usePayroll from '../hooks/UsePayroll';

const PayrollTable = () => {
  const style = useMemo(() => PayrollStyle(), []);
  const [anchorEl, setAnchorEl] = useState(null);
  const { blockUI, snackbarUI } = useUI();
  const payrollService = useMemo(() => new PayrollService(), []);
  const [itemSelected, setItemSelected] = useState(null);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const {
    currentTab,
  } = useContext(payrollContext);
  const [open, setOpen] = useState(false);
  const [dataYtd, setDataYtd] = useState([]);

  const {certificationGroups, getCertificationTargetGroups, createTargetGroup} = usePayroll();
  const [openConfirm, setOpenConfirm] = useState(false);
  const [pendingChange, setPendingChange] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState('');
  const [openNewTarget, setOpenNewTarget] = useState(false);
  const [pendingRow, setPendingRow] = useState(null);

  useEffect(() => {
    getCertificationTargetGroups();
  }, []);

  const handleClickNotes = (event, item) => {
    setItemSelected(item)
    setAnchorEl(event.currentTarget);
  };

  const handleCloseModal = () => {
    setAnchorEl(null);
    setItemSelected(null)
    setOpenModalEdit(false)
  };

  const handleOpenModalEdit = (item) => {
    setItemSelected(item);
    setOpenModalEdit(true);
  }

  const employerName = (name) => {
    if(name?.length > 40)return `${name?.substring(0, 40)}...`;
    return name;
  }

  const getYtdValue = async (employeeId) => {
    try {
        blockUI.current.open(true);
        const response = await payrollService.getYtdByEmployees(employeeId);
        setDataYtd(response?.data?.data);
        blockUI.current.open(false);
    } catch (error) {
        blockUI.current.open(false);
        AppHelper.checkError(error, snackbarUI);
    }
  } 

  const handleOpenModal = (employeeId) => {
    getYtdValue(employeeId);
    setOpen(true);
  }

  const handleCloseModalYtd = () => setOpen(false);

  const wotcCreditMultiplier = (value) => {
    if(value !== null & value !== undefined)return `${value}%`;
    return 
  }

  const onCertificationGroup = (e, row, refreshCallback) => {
    const {value} = e.target;
    if (value === 'NEW_TARGET') {
      setPendingRow(row);
      setOpenNewTarget(true);
      return;
    }
    const DATA = {
      note: row?.note ?? '',
      certifiedTargetGroupId: value ? value : null,
    };

    const selectedTarget = certificationGroups.find(
      x => x.id === value
    );

    const newMaxWage = selectedTarget?.maxWage;
    const currentYtd = row?.currentYTDGrossWages;

    if (newMaxWage && currentYtd > newMaxWage) {
      setPendingChange({
        data: DATA,
        employeeId: row?.employeeId,
        refreshCallback,
      });
      setConfirmMessage(
        `The employee's current YTD Gross Wage is $${currentYtd}.
        The maximum wage for the selected target group is $${newMaxWage}.
        Are you sure you want to continue with this change?`
      );
      setOpenConfirm(true);
    } else {
      callForUpdateEmployee(DATA, row?.employeeId, refreshCallback);
    }
  };

  const handleConfirmDialog = async (response) => {
    if (response && pendingChange) {
      await callForUpdateEmployee(
        pendingChange.data,
        pendingChange.employeeId,
        pendingChange.refreshCallback
      );
    }

    setOpenConfirm(false);
    setPendingChange(null);
  };

  const handleSaveNewTarget = async (newTarget) => {
    const success = await createTargetGroup(newTarget);
      if (success) {
        setOpenNewTarget(false);
        setPendingRow(null);
      }
      return success;
    };

  const handleCloseNewTarget = () => {
    setOpenNewTarget(false);
    setPendingRow(null);
  };

  const callForUpdateEmployee = async (data, employeeId, refreshCallback) => {
    try {
      blockUI.current.open(true);
      await payrollService.updateEmploye(employeeId, data)
      blockUI.current.open(false);
      if (refreshCallback) refreshCallback();
    } catch (error) {
      blockUI.current.open(false);
      AppHelper.checkError(error, snackbarUI);
    }
  }

 
  return (
    <>
      <Paper elevation={4}>
        <ToolbarPayroll/>
          {
            currentTab === 1 || currentTab === 2
              ? <>
                  <FilterCompany/>
                  <HierarchicalPayrollTable
                    employeeHandlers={{
                      handleClickNotes,
                      handleOpenModalEdit,
                      handleOpenModal,
                      onCertificationGroup,
                      certificationGroups,
                      wotcCreditMultiplier,
                      employerName,
                    }}
                  />
                </>
              : <InvoiceSumary />
          }

        <DialogNotes
          anchorEl={anchorEl}
          handleClose={handleCloseModal}
          idItemSelected={itemSelected}
        />

        <EditItemPayroll
          open={openModalEdit}
          handleClose={handleCloseModal}
          data={itemSelected}
        />
      </Paper>

      <YTDModal
        open={open}
        handleClose={handleCloseModalYtd}
        dataYtd={dataYtd}
      />

      <ConfirmationDialog
        open={openConfirm}
        onClose={handleConfirmDialog}
        view="payroll"
        title={confirmMessage}
      />

      <DialogNewTargetGroup
        open={openNewTarget}
        onClose={handleCloseNewTarget}
        onCreate={handleSaveNewTarget}
      />
    </>
  )
}

export default PayrollTable
